import RecruitmentStudentsModalWindow from './recruitment-students-modal-window'

export default RecruitmentStudentsModalWindow
